import logoPragmatic from '@/assets/images/logo/logo_pragmatic_play.png'
import logoMicrogaming from '@/assets/images/logo/logo_microgaming.png'
import logoNetent from '@/assets/images/logo/logo_netend.png'
import logoBng from '@/assets/images/logo/logo_bng.png'
import logoPlayngo from '@/assets/images/logo/logo_playngo.png'
import logoNolimit from '@/assets/images/logo/logo_Nolimit_City.png'
import logoJili from '@/assets/images/logo/logo_JILI.png'
import logoBgaming from '@/assets/images/logo/logo_bgaming.png'
import logoCq9 from '@/assets/images/logo/logo_CQ9.png'
import logoPlaytech from '@/assets/images/logo/logo_PlayTech.png'
import logoHabanero from '@/assets/images/logo/logo_Habanero.png'
import logoWazdan from '@/assets/images/logo/logo_Wazdan.png'
import logoRedtiger from '@/assets/images/logo/logo_redtiger.png'
import logoFatpanda from '@/assets/images/logo/logo_FatPanda.png'
import logoJdb from '@/assets/images/logo/logo_JDB.png'
import logoRelax from '@/assets/images/logo/logo_Relax Gaming .png'
import logo1x2 from '@/assets/images/logo/logo_1X2 Gaming .png'
import logoRevolver from '@/assets/images/logo/logo_revolver.png'
// gold8.bet 게임사 화면(GenericCasino) 왼쪽 위 로고 — 원본에서 받은 그림(405×100, 화면 284×70)
import lobbyLogoMg from '@/assets/images/gold-lobby/logo/mg.png'
import lobbyLogoPng from '@/assets/images/gold-lobby/logo/png.png'
import lobbyLogoPp from '@/assets/images/gold-lobby/logo/pp.png'
import lobbyLogoNlc from '@/assets/images/gold-lobby/logo/nlc.png'
import lobbyLogoPt from '@/assets/images/gold-lobby/logo/pt.png'
import lobbyLogoTp from '@/assets/images/gold-lobby/logo/tp.png'
import lobbyLogoJl from '@/assets/images/gold-lobby/logo/jl.png'
import lobbyLogoYgg from '@/assets/images/gold-lobby/logo/ygg.png'
import lobbyLogoHg from '@/assets/images/gold-lobby/logo/hg.png'
import lobbyLogoCq9 from '@/assets/images/gold-lobby/logo/cq9.png'
import lobbyLogoHs from '@/assets/images/gold-lobby/logo/hs.png'
import lobbyLogoHb from '@/assets/images/gold-lobby/logo/hb.png'
import lobbyLogoFc from '@/assets/images/gold-lobby/logo/fc.png'
import lobbyLogoFtg from '@/assets/images/gold-lobby/logo/ftg.png'

/** 벤더 name → 로고 이미지 매핑 (게임 목록 페이지 왼쪽 위 로고) */
export const VENDOR_LOGO_MAP = {
  'プラグマティック': logoPragmatic,
  'マイクロゲーミング': logoMicrogaming,
  'ネットエント': logoNetent,
  'ブウンゴ': logoBng,
  'プレインゴー': logoPlayngo,
  'ノーリミット・シティ': logoNolimit,
  'JILI': logoJili,
  'BGAMING': logoBgaming,
  'CQ9': logoCq9,
  'プレイテック': logoPlaytech,
  'ハバネロ': logoHabanero,
  'ワズダン': logoWazdan,
  'レッド・タイガー': logoRedtiger,
  'ファット・パンダ': logoFatpanda,
  'JDB': logoJdb,
  'RELAX GAMING': logoRelax,
  '1X2 GAMING': logo1x2,
  'リボルバー': logoRevolver,
}

/** 메뉴 이름(어드민 메뉴 설정의 게임사 약자 MG·PP …) → gold8.bet 게임사 화면 로고 */
export const GOLD_LOBBY_LOGO_MAP = {
  MG: lobbyLogoMg,
  PNG: lobbyLogoPng,
  PP: lobbyLogoPp,
  NLC: lobbyLogoNlc,
  PT: lobbyLogoPt,
  TP: lobbyLogoTp,
  JL: lobbyLogoJl,
  YGG: lobbyLogoYgg,
  HG: lobbyLogoHg,
  CQ9: lobbyLogoCq9,
  HS: lobbyLogoHs,
  HB: lobbyLogoHb,
  FC: lobbyLogoFc,
  FTG: lobbyLogoFtg,
}

/** 게임사 화면 로고 — 메뉴 약자로 먼저 찾고, 없으면 예전 일본어 이름 매핑. 둘 다 없으면 null(이름 글자로 표시) */
export const getLobbyLogo = (name) => {
  if (!name) return null
  return GOLD_LOBBY_LOGO_MAP[String(name).trim().toUpperCase()] || VENDOR_LOGO_MAP[name] || null
}
